import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

const getMissingSupabaseEnv = () => {
  const missing = [];
  if (!supabaseUrl) missing.push('VITE_SUPABASE_URL');
  if (!supabaseAnonKey) missing.push('VITE_SUPABASE_ANON_KEY');
  return missing;
};

export function getSupabaseConfig() {
  const missing = getMissingSupabaseEnv();

  if (missing.length > 0) {
    if (import.meta.env.DEV) {
      console.warn('[Supabase] Missing env vars:', missing.join(', '));
    }

    return {
      ok: false,
      missing,
      error: 'Configuration manquante. Contactez l\'administrateur.'
    };
  }

  return { ok: true, missing: [], error: null };
}

export const supabase =
  supabaseUrl && supabaseAnonKey
    ? createClient(supabaseUrl, supabaseAnonKey, {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: true
        }
      })
    : null;
